import { ConfigurazioneFrontEnd, ConfigurazionePratica } from './configurazione.model';

export enum TipoConfermaPratica {
  NESSUNO = 'NESSUNO',
  OTP = 'OTP',
  FIRMA = 'FIRMA',
}

export enum TipoPraticaStatus {
  IN_ATTESA = 'IN_ATTESA',
  RICEZIONE_RICHIESTE = 'RICEZIONE_RICHIESTE',
  NUOVA_RICEZIONE_RICHIESTE = 'NUOVA_RICEZIONE_RICHIESTE',
  CHIUSA = 'CHIUSA',
  ARCHIVIATA = 'ARCHIVIATA',
}

export enum TipoRicezioneOTP {
  SMS = 'SMS',
  WHATSAPP = 'WHATSAPP',
  EMAIL = 'EMAIL',
}

export enum VisualizzazionePratica {
  SEMPRE = 'SEMPRE',
  SOLO_DASHBOARD = 'SOLO_DASHBOARD',
  NO_FE_UTENTE = 'NO_FE_UTENTE',
}

export interface ComuneInfoDTO {
  id?: string;
  nomeComune?: string;
  slugComune?: string;
  urlLogoComune?: string;
  urlFrontEnd?: string;
  email?: string;
}

export interface TipoPratica {
  id?: number;
  codice?: string;
  slugComune?: string;
  titolo?: string;
  descrizione?: string;
  tipoPraticaStatus?: TipoPraticaStatus;
  tipologiaPratica?: string;
  visualizzazionePratica?: VisualizzazionePratica;
  configurazionePratica?: ConfigurazionePratica;
  configurazioneFrontEnd?: ConfigurazioneFrontEnd;
  comune?: ComuneInfoDTO;
  created_at?: string;
  updated_at?: string;
}
